import styled from 'styled-components';

interface FlexWrapperProps {
  display?: 'flex' | 'inline-flex';
  itemalign?: 'stretch' | 'flex-start' | 'flex-end' | 'center' | 'baseline';
  justifycontent?:
    | 'flex-start'
    | 'flex-end'
    | 'center'
    | 'space-between'
    | 'space-around'
    | 'space-evenly'
    | 'normal';
  direction?: 'row' | 'column';
  gap?: string;
  flex?: string;
  flexwrap?: 'nowrap' | 'wrap' | 'wrap-reverse';
  margin?: string;
  contain?: boolean;
  padding?: string;
  background?: string;
  borderRadius?: string;
  maxWidth?: string;
  minHeight?: string;
  height?: string;
  fullHeight?:boolean;
  fullContent?:boolean;
}

export const FlexWrapper = styled.div<FlexWrapperProps>`
  margin: ${({ margin }) => margin || '0px'}; 
  display: ${({ display }) => display || 'flex'};
  align-items: ${({ itemalign }) => itemalign || 'stretch'};
  justify-content: ${({ justifycontent }) => justifycontent || 'flex-start'};
  flex-direction: ${({ direction }) => direction || 'row'};
  gap: ${({ gap }) => gap || '15px'};
  flex-wrap: ${({ flexwrap }) => flexwrap || 'wrap'};
  flex: ${({ flex }) => flex || 'auto'};
  padding: ${({ padding }) => padding ?? '0px'};
  background-color: ${({ background }) => background ?? 'transparent'};
  border-radius: ${({ borderRadius }) => borderRadius ?? '0'};
  max-width: ${({ maxWidth }) => maxWidth ?? '100%'};
  height: ${({ height }) => height ?? 'auto'};
  ${({ fullHeight }) => fullHeight && 'height:calc(100vh - 143px)'};
  flex: ${({ flex }) => flex || '1'};
  min-height:  ${({ minHeight }) => minHeight || 'auto'};
  ${({ fullContent }) => fullContent && 'flex: 1;'}
`;
